"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSpeedToBft = exports.convertSpeed = void 0;
var CoreFunctions_1 = require("./CoreFunctions");
var SpeedFactors = {
    ms: 1.94384449,
    kn: 1
};
function convertSpeed(value, options) {
    if (options === void 0) { options = {}; }
    var _a = options.fromUnit, fromUnit = _a === void 0 ? 'kn' : _a, _b = options.toUnit, toUnit = _b === void 0 ? 'ms' : _b;
    if (CoreFunctions_1.CoreFunctions.isNil(value)) {
        return NaN;
    }
    var valueInKn = Math.abs(value) * SpeedFactors[fromUnit];
    return valueInKn * (1 / SpeedFactors[toUnit]);
}
exports.convertSpeed = convertSpeed;
var BftLimits = {
    kn: [1, 4, 7, 11, 17, 22, 28, 34, 41, 48, 56, 64, Number.MAX_VALUE],
    ms: [0.5, 1.6, 3.4, 5.5, 8, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7, Number.MAX_VALUE]
};
function convertSpeedToBft(value, options) {
    if (options === void 0) { options = {}; }
    var _a = options.fromUnit, fromUnit = _a === void 0 ? 'kn' : _a;
    if (CoreFunctions_1.CoreFunctions.isNil(value)) {
        return NaN;
    }
    var parsedValue = Math.abs(value);
    return BftLimits[fromUnit].findIndex(function (limit) { return parsedValue < limit; });
}
exports.convertSpeedToBft = convertSpeedToBft;
